import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import {
  type ReactElement,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from 'react';

export interface CollapsibleSectionHandle {
  open: () => void;
}

export interface CollapsibleSectionProps {
  iconName: Parameters<typeof Icon>[0]['name'];
  title: string;
  children: ReactElement;
}

export const CollapsibleSection = forwardRef<
  CollapsibleSectionHandle,
  CollapsibleSectionProps
>(({ iconName, title, children }, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = useCallback(() => setIsOpen((prev) => !prev), []);

  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
  }));

  return (
    <div className="stability-sidecar__collapsible">
      <button
        type="button"
        className="stability-sidecar__collapsible-header"
        onClick={handleToggle}
      >
        <div className="flex flex__ai--center gap-s">
          <Icon name={iconName} size={IconSizeClasses.XSmall} />
          <span className="font-weight-medium">{title}</span>
        </div>
        <Icon name={isOpen ? 'up' : 'down'} size={IconSizeClasses.XSmall} />
      </button>
      {isOpen && <div>{children}</div>}
    </div>
  );
});
